/*
 * jj-read-more.js  (James 3.12.0)
 * --------------------------------------------------------------------------
 * Progressive enhancement for <jj-read-more> (Rich text block "Collapse long
 * text" setting, e.g. the PDP's {{ product.description }}).
 *
 * SEO: the FULL text is always in the server-rendered HTML. CSS hides part of
 * it until the shopper opens it, and the toggle is a checkbox + label that
 * works with CSS alone, so nothing is ever unrevealable or fetched on click.
 *
 * This script only refines:
 *   - "first" mode: cut after the first NON-EMPTY <p> (CSS alone uses
 *     p:first-of-type, which an empty leading <p> would fool);
 *   - descriptions with no top-level <p> fall back to "lines";
 *   - nothing to hide -> remove the toggle and show everything;
 *   - "Read less" scrolls the block back into view if its top is off-screen.
 * --------------------------------------------------------------------------
 */
(function () {
  if (!window.customElements || customElements.get('jj-read-more')) return;

  function hasContent(el) {
    return el.textContent.replace(/ /g, ' ').trim() !== '' || !!el.querySelector('img, iframe, video, table');
  }

  class JJReadMore extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.state = this.querySelector('.jj-readmore__state');
      this.content = this.querySelector('.jj-readmore__content');
      if (!this.state || !this.content) return;

      var needed = this.dataset.mode === 'lines' ? this.needsLines() : this.setupFirst();
      this.classList.add('is-ready');
      if (!needed) {
        this.classList.add('is-static');
        this.state.checked = true;
        this.state.disabled = true;
        return;
      }
      this.state.addEventListener('change', this.onChange.bind(this));
    }

    setupFirst() {
      var kids = Array.from(this.content.children);
      var lead = kids.find(function (el) {
        return el.tagName === 'P' && hasContent(el);
      });
      if (!lead) {
        this.classList.remove('jj-readmore--first');
        this.classList.add('jj-readmore--lines');
        this.dataset.mode = 'lines';
        return this.needsLines();
      }
      var rest = kids.slice(kids.indexOf(lead) + 1);
      if (!rest.some(hasContent)) return false;
      rest.forEach(function (el) { el.setAttribute('data-jj-cut', ''); });
      return true;
    }

    needsLines() {
      return this.content.scrollHeight > this.content.clientHeight + 4;
    }

    onChange() {
      if (!this.state.checked && this.getBoundingClientRect().top < 0) {
        this.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }
  }

  customElements.define('jj-read-more', JJReadMore);
})();
